import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faChild, faGlassMartiniAlt, faWifi, faEuroSign } from '@fortawesome/free-solid-svg-icons';
import { BrowserRouter, Link, Switch, Route } from "react-router-dom";
import { Base64 } from 'js-base64';
import NewHeader from "./Component/NewHeader/NewHeader";
import moment from 'moment';
import {Helmet} from "react-helmet";

import { getExprerianceShowDataBooking, getAccomodationShowDataBooking } from './Component/axios';

import './BookingPage.css'
import BookingPageSkeleton from './BookingPageSkeleton';
import Skeleton from "react-loading-skeleton";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

function BookingPage(props) {

    const [Time, setTime] = useState(null);
    const [TransactionID, setTransactionID] = useState();
    const [Message, setMessage] = useState();
    const [Status, setStatus] = useState();
    const [upcomingData, setupcomingData] = useState(null);
    const [upcomingTourData, setupcomingTourData] = useState(null);


//    const starsCount = (HotelCategory) => {
//         if (HotelCategory == 1) {
//           return (
//             <>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//             </>
//           );
//         } else if (HotelCategory == 2) {
//           return (
//             <>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//             </>
//           );
//         } else if (HotelCategory == 3) {
//           return (
//             <>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//             </>
//           );
//         } else if (HotelCategory == 4) {
//           return (
//             <>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#ccc"></FontAwesomeIcon>
//             </>
//           );
//         } else if (HotelCategory == 5) {
//           return (
//             <>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//               <FontAwesomeIcon icon={faStar} color="#000"></FontAwesomeIcon>
//             </>
//           );
//         }
//     };

    useEffect(() => {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
       
         const tour_time = urlParams.get('tour_time');
       
        const transaction_id = urlParams.get('transaction_id');
        const transaction_uid = urlParams.get('transaction_uid');
        const message = urlParams.get('message');
        const status = urlParams.get('status');

      
        setTime(tour_time);
      
        setTransactionID(transaction_id);
        setMessage(message);
        setStatus(status);

        getAccomodationShowDataBooking(transaction_uid).then(
            (data) => {
              //this.setState({ upcomingData: data });
              setupcomingData(data);
            },
            (error) => { }
          );

          getExprerianceShowDataBooking(transaction_uid).then(
            (data) => {
              console.log(data);
             //this.setState({ upcomingTourData: data });
             setupcomingTourData(data);
            },
            (error) => { }
          );

    }, [])

   // console.log(TransactionID);
   // console.log(HotelData.id);
    return (
        <>
         <Helmet>
            <title> Booking Confirmation @ Holidays Seychelles</title>
            <meta name="keywords" content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"/>
        </Helmet>
        <h1 style={{color:'#fff'}}> Booking Confirmation @ Holidays Seychelles</h1>
            <NewHeader page={'inner_listing'} />
            <div>
                <h2 style={{marginTop: '8%', textAlign: 'center',  fontWeight: 600}} >Thank you for booking with us</h2>
                <p style={{ textAlign: 'center'}}>Please Find You're booking details</p>
                <div className="container makeFlex spaceBetween">
                     
                             
                    <div className="" style={{ padding: '40px' }}>
                     
                        <p class="errorLinkText latoBold font16 blueText" style={{ marginBottom: '10px' }}><Link to="/PlanTrips">Back To My Booking</Link></p>
                        {upcomingData == null || upcomingTourData == null ? (
                            <>
                            
                            <div className="Container-TileBooking" style={{height: 360, padding: 40 }}>
        
                            <div className="Detail-Hotel">
                                <div className="Hotel-Name" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                
                                    <div className="nameContainer" style={{ width: 600 }}></div>
                              <div
                                className="Container-Tile"
                                style={{ height: 250 }}
                              >
                                <div className="ContainerFlex">
                                  <div
                                    className="ContainerImage"
                                    style={{ padding: "15px 10px 10px 10px" }}
                                  >
                                    <Skeleton
                                      style={{ width: "100%", height: "165px" }}
                                    />
                                  </div>
                                  <div
                                    className="ContainerContent"
                                    style={{ padding: "10px 10px 10px 40px" }}
                                  >
                                    <div
                                      className="nameContainer"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="paymakeFlex appendBottom5">
                                        <h3 className="latoBlack font22 blackText">
                                          <Skeleton
                                            style={{ width: "200px" }}
                                          />
                                        </h3>
                                        <span
                                          className="sRating"
                                          style={{
                                            display: "inline-flex",
                                            marginTop: "5px",
                                            marginLeft: "10px",
                                          }}
                                        >
                                          <Skeleton
                                            style={{ width: "100px" }}
                                          />
                                        </span>
                                      </div>
                                      <p>
                                        <Skeleton style={{ width: "300px" }} />
                                      </p>
                                      <h3
                                        className="latoBlack font22 blackText"
                                        style={{
                                          marginTop: 10,
                                          fontSize: 18,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <Skeleton style={{ width: "150px" }} />
                                      </h3>

                                      <div class="chkContBooking">
                                        <div class="chkCont__col">
                                          <div class="paymakeFlex column">
                                            <span class="font10 grayText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="latoBlack font24 blackText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="font10 grayText 444">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                          <div class="chkCont__night">
                                            <span>
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                          <div class="paymakeFlex column">
                                            <span class="font10 grayText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="latoBlack font24 blackText appendBottom3">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                            <span class="font10 grayText">
                                              <Skeleton
                                                style={{ width: 150 }}
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              </div>
                              </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {upcomingData.ejuniper && (
                                <>
                                  {" "}
                                  {upcomingData.ejuniper.propertyData.map(
                                    (item, index) => {
                                      const DataArrShow =
                                      item.ReadBookingResponse.BookingRS
                                        .Reservations.Reservation.Items
                                        .HotelItem;
                                        if(Array.isArray(DataArrShow)){
                                          const locatorIndex = item.locatorIndex; 
                                          let HotelCategory = "";
                                          let StatusMsg = "";
                                          let numberOfNights = "";
                                          let HotelName = "";
                                          let HotelRoom = "";
                                          let PriceAmount = "";
                                          let price_uplift = "";
                                          let UpliftAmount = "";
                                          let AmountWithUpliftOld = "";
                                          let AddressInfo = "";
                                          let StartDate = "";
                                          let EndDate = "";
                                          let CancellationPolicy = "";
                                          let Locator = "";
                                          let propertypdf = "";
                                          DataArrShow.map(
                                            (BookingEjuniferitem, index) => {
                                           // console.log(BookingEjuniferitem);
                                          if(locatorIndex == index){
                                          const DataArr = BookingEjuniferitem;
                                           
                                            const HotelCategoryNew =
                                              DataArr.HotelInfo.HotelCategory;

                                             HotelName = DataArr.HotelInfo.Name;
                                             HotelRoom =  DataArr.HotelRooms.HotelRoom.Name
      
                                           HotelCategory = HotelCategoryNew.charAt(
                                              0
                                            );
                                            
                                            let date1 = new Date(
                                              DataArr.attributes.Start
                                            );
                                            let date2 = new Date(
                                              DataArr.attributes.End
                                            );
      
                                            let timeDiff = Math.abs(
                                              date1.getTime() - date2.getTime()
                                            );
                                             numberOfNights = Math.ceil(
                                              timeDiff / (1000 * 3600 * 24)
                                            );
                                            StartDate = DataArr.attributes.Start;
                                            EndDate = DataArr.attributes.End;
                                            const Status =
                                        item.ReadBookingResponse.BookingRS
                                          .Reservations.Reservation.attributes
                                          .Status;
                                     Locator =
                                        item.ReadBookingResponse.BookingRS
                                          .Reservations.Reservation.attributes
                                          .Locator;
                                      CancellationPolicy =
                                        DataArr.CancellationPolicy.PolicyRules
                                          .Rule;
                                          PriceAmount=  parseFloat(DataArr.Prices.Price
                                          .TotalFixAmounts.Service
                                          .attributes.Amount);
                                         
                                       price_uplift = parseFloat(upcomingData.ejuniper.uplift[index]);
                                      UpliftAmount =parseFloat((price_uplift / 100) * PriceAmount);
                                       AmountWithUpliftOld =  parseFloat(PriceAmount + UpliftAmount); // Amount
                                      
                                         
                                          if (Status == "PAG") {
                                            StatusMsg =
                                              "Booking confirmed and paid";
                                          } else if (Status == "OK") {
                                            StatusMsg = "Booking confirmed";
                                          } else if (Status == "CON") {
                                            StatusMsg = "Booking confirmed";
                                          } else if (Status == "CAN") {
                                            StatusMsg = "Booking cancelled";
                                          } else if (Status == "CAC") {
                                            StatusMsg = "Booking cancelled";
                                          } else if (Status == "PRE") {
                                            StatusMsg = "Booking on request";
                                          } else if (Status == "PDI") {
                                            StatusMsg = "Booking on request";
                                          } else if (Status == "QUO") {
                                            StatusMsg = "Quotation";
                                          }else{
                                            StatusMsg ="We will try to rebook the same. In case if you don’t hear from us in next 24 Hours, you can mail  us at info@holidays-seychelles.com or contact us at +248 437 6666";
                                          }

                                    
                                    }
                                          })
                                          return (
                                            <>
                                              <div className="Container-Tile">
                                                <div className="ContainerFlex">
                                                  <div
                                                    className="ContainerImage"
                                                    style={{
                                                      padding: "15px 1px 10px 1px",
                                                    }}
                                                  >
                                                    <img
                                                    src={
                                                      upcomingData
                                                        .ejuniper.property_image[
                                                      index
                                                      ][0]
                                                    }
                                                  />
                                                  </div>
                                                  <div
                                                    className="ContainerContent"
                                                    style={{
                                                      padding:
                                                        "10px 10px 10px 10px",
                                                    }}
                                                  >
                                                    <div
                                                      className="nameContainer"
                                                      style={{ width: "100%" }}
                                                    >
                                                      <div className="paymakeFlexNew">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <h3
                                                        className="latoBlack font22 blackText"
                                                        style={{ fontSize: 25 }}
                                                      >
                                                        {HotelName}
                                                      </h3>
                                                      
                                                    </div>
                                                   
                                                  </div>
                                                  
                                                     <p style={{ marginTop: 15 }}>
                                                        {AddressInfo}
                                                      </p>

                                                      <h3
                                                        className="latoBlack font22 blackText"
                                                        style={{
                                                          marginTop: 5,
                                                          fontSize: 18,
                                                          marginBottom: 2,
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        {
                                                         HotelRoom &&(HotelRoom.replace("</br>", ", "))
                                                        }
                                                      </h3>
    
                                                      <h3
                                                        className="latoBlack font22 blackText"
                                                        style={{
                                                          fontSize: 18,
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        Amount :{" "}
                                                        <FontAwesomeIcon
                                                          icon={faEuroSign}
                                                          style={{ fontSize: 16 }}
                                                          color="#000"
                                                        ></FontAwesomeIcon>{" "}
                                                        {
                                                          AmountWithUpliftOld
                                                        }
                                                      </h3> 
                                                      <h3
                                                        className="latoBlack font22 blackText"
                                                        style={{
                                                          fontSize: 18,
                                                          fontWeight: "bold",
                                                        }}
                                                      >
                                                        Status: {StatusMsg}
                                                      </h3> 
                                                      {/* <p>Message: {Message}</p>
                                                    <p>Transaction Id: {TransactionID}</p> */}
    
                                                      <div
                                                        class="chkContBooking"
                                                        style={{ marginTop: 12 }}
                                                      >
                                                        <div class="chkCont__col">
                                                          <div class="paymakeFlex column">
                                                            <span class="font10 grayText appendBottom3">
                                                              CHECK IN
                                                            </span>
                                                            <span class="latoBlack font24 blackText appendBottom3">
                                                              {moment(
                                                                StartDate
                                                              ).format("D MMM Y")}
                                                            </span>
                                                            <span class="font10 grayText 444">
                                                              {moment(
                                                               StartDate
                                                              ).format("dddd")}
                                                            </span>
                                                          </div>
                                                          <div class="chkCont__night">
                                                            <span>
                                                              {numberOfNights}{" "}
                                                              Nights
                                                            </span>
                                                          </div>
                                                          <div class="paymakeFlex column">
                                                            <span class="font10 grayText appendBottom3">
                                                              CHECK OUT
                                                            </span>
                                                            <span class="latoBlack font24 blackText appendBottom3">
                                                              {moment(
                                                                EndDate
                                                              ).format("D MMM Y")}
                                                            </span>
                                                            <span class="font10 grayText">
                                                              {moment(
                                                               EndDate
                                                              ).format("dddd")}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>


                                                </div>
                                              </div>
                                             
                                            </>
                                          );
  
                                        }else{

                                      const DataArr = 
                                        item.ReadBookingResponse.BookingRS
                                          .Reservations.Reservation.Items
                                          .HotelItem;
                                      const HotelCategoryNew =
                                        DataArr.HotelInfo.HotelCategory;

                                      let  PriceAmount = parseFloat(DataArr.Prices.Price.TotalFixAmounts.Service.attributes.Amount);
                                      let  price_uplift = parseFloat(upcomingData.ejuniper.uplift[index]);
                                      let UpliftAmount =parseFloat((price_uplift / 100) * PriceAmount);
                                      let AmountWithUpliftOld =  parseFloat(PriceAmount + UpliftAmount); // Amount

                                      const HotelCategory = HotelCategoryNew.charAt(
                                        0
                                      );
                                      let date1 = new Date(
                                        DataArr.attributes.Start
                                      );
                                      let date2 = new Date(
                                        DataArr.attributes.End
                                      );

                                      let timeDiff = Math.abs(
                                        date1.getTime() - date2.getTime()
                                      );
                                      let numberOfNights = Math.ceil(
                                        timeDiff / (1000 * 3600 * 24)
                                      );


                                      const Status =
                                        item.ReadBookingResponse.BookingRS
                                          .Reservations.Reservation.attributes
                                          .Status;
                                      const Locator =
                                        item.ReadBookingResponse.BookingRS
                                          .Reservations.Reservation.attributes
                                          .Locator;
                                      const CancellationPolicy =
                                        DataArr.CancellationPolicy.PolicyRules
                                          .Rule;

                                      let StatusMsg = "";
                                      if (Status == "PAG") {
                                        StatusMsg =
                                          "Booking confirmed and paid";
                                      } else if (Status == "CON") {
                                        StatusMsg = "Booking confirmed";
                                      } else if (Status == "CAN") {
                                        StatusMsg = "Booking cancelled";
                                      } else if (Status == "CAC") {
                                        StatusMsg = "Booking cancelled";
                                      } else if (Status == "PRE") {
                                        StatusMsg = "Booking on request";
                                      } else if (Status == "PDI") {
                                        StatusMsg = "Booking on request";
                                      } else if (Status == "QUO") {
                                        StatusMsg = "Quotation";
                                      }else{
                                        StatusMsg = "We will try to rebook the same. In case if you don’t hear from us in next 24 Hours, you can mail  us at info@holidays-seychelles.com or contact us at +248 437 6666";
                                      }

                                   
                                      return (
                                        <>
                                          <div className="Container-Tile">
                                            <div className="ContainerFlex">
                                              <div
                                                className="ContainerImage"
                                                style={{
                                                  padding: "15px 1px 10px 1px",
                                                }}
                                              >
                                                <img
                                                  src={
                                                    upcomingData
                                                      .ejuniper.property_image[
                                                    index
                                                    ][0]
                                                  }
                                                />
                                              </div>
                                              <div
                                                className="ContainerContent"
                                                style={{
                                                  padding:
                                                    "10px 10px 10px 10px",
                                                }}
                                              >
                                                <div
                                                  className="nameContainer"
                                                  style={{ width: "100%" }}
                                                >
                                                  <div className="paymakeFlexNew">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <h3
                                                        className="latoBlack font22 blackText"
                                                        style={{ fontSize: 25 }}
                                                      >
                                                        {DataArr.HotelInfo.Name}
                                                      </h3>
                                                      {/* <span
                                                        className="sRating"
                                                        style={{
                                                          display:
                                                            "inline-flex",
                                                          marginTop: "5px",
                                                          marginLeft: "10px",
                                                        }}
                                                      >
                                                        {this.starsCount(
                                                          HotelCategory
                                                        )}
                                                      </span> */}
                                                    </div>
                                                    
                                                  </div>
                                                 
                                                  <p>
                                                    {DataArr.HotelInfo.Address}
                                                  </p>

                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      marginTop: 5,
                                                      fontSize: 18,
                                                      marginBottom: 2,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    {
                                                      DataArr.HotelRooms
                                                      .HotelRoom.Name &&(DataArr.HotelRooms
                                                        .HotelRoom.Name.replace("</br>", ", "))
                                                      
                                                    }
                                                  </h3>

                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      fontSize: 18,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Amount :{" "}
                                                    <FontAwesomeIcon
                                                      icon={faEuroSign}
                                                      style={{ fontSize: 16 }}
                                                      color="#000"
                                                    ></FontAwesomeIcon>{" "}
                                                    {
                                                      AmountWithUpliftOld.toFixed(2)
                                                    }
                                                  </h3>
                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      fontSize: 18,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Status: {StatusMsg}
                                                  </h3>
                                                  {/* <p>Message: {Message}</p>
                                                    <p>Transaction Id: {TransactionID}</p> */}

                                                  <div
                                                    class="chkContBooking"
                                                    style={{ marginTop: 12 }}
                                                  >
                                                    <div class="chkCont__col">
                                                      <div class="paymakeFlex column">
                                                        <span class="font10 grayText appendBottom3">
                                                          CHECK IN
                                                        </span>
                                                        <span class="latoBlack font24 blackText appendBottom3">
                                                          {moment(
                                                            DataArr.attributes
                                                              .Start
                                                          ).format("D MMM Y")}
                                                        </span>
                                                        <span class="font10 grayText 444">
                                                          {moment(
                                                            DataArr.attributes
                                                              .Start
                                                          ).format("dddd")}
                                                        </span>
                                                      </div>
                                                      <div class="chkCont__night">
                                                        <span>
                                                          {numberOfNights}{" "}
                                                          Nights
                                                        </span>
                                                      </div>
                                                      <div class="paymakeFlex column">
                                                        <span class="font10 grayText appendBottom3">
                                                          CHECK OUT
                                                        </span>
                                                        <span class="latoBlack font24 blackText appendBottom3">
                                                          {moment(
                                                            DataArr.attributes
                                                              .End
                                                          ).format("D MMM Y")}
                                                        </span>
                                                        <span class="font10 grayText">
                                                          {moment(
                                                            DataArr.attributes
                                                              .End
                                                          ).format("dddd")}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                     
                                    } 
                                    }
                                  )}
                                </>
                              )}

                              {upcomingData.hotel_link && (
                                <>
                                  {" "}
                                  {upcomingData.hotel_link.propertyData.map(
                                    (item, index) => {
                                      console.log(item);
                                      let date1 = new Date(
                                        upcomingData.hotel_link.bookingArr[
                                          index
                                        ].booking_checked_in
                                      );
                                      let date2 = new Date(
                                        upcomingData.hotel_link.bookingArr[
                                          index
                                        ].booking_checked_out
                                      );

                                      let timeDiff = Math.abs(
                                        date1.getTime() - date2.getTime()
                                      );
                                      let numberOfNights = Math.ceil(
                                        timeDiff / (1000 * 3600 * 24)
                                      );
                                      const Status = upcomingData
                                        .hotel_link.bookingArr[index]
                                        .booking_status;
                                        let hsbooking_id = upcomingData
                                        .hotel_link.bookingArr[index].id;

                                        
                                      let StatusMsg = "";
                                      if (Status == 1) {
                                        StatusMsg = "Booking confirmed";
                                      }else{
                                        StatusMsg = "We will try to rebook the same. In case if you don’t hear from us in next 24 Hours, you can mail  us at info@holidays-seychelles.com or contact us at +248 437 6666";
                                      }
                                      return (
                                        <>
                                          <div className="Container-Tile">
                                            <div className="ContainerFlex">
                                              <div
                                                className="ContainerImage"
                                                style={{
                                                  padding: "15px 1px 10px 1px",
                                                }}
                                              >
                                                <img
                                                  src={
                                                    upcomingData
                                                      .hotel_link
                                                      .property_image[index][0]
                                                  }
                                                />
                                              </div>
                                              <div
                                                className="ContainerContent"
                                                style={{
                                                  padding:
                                                    "10px 10px 10px 10px",
                                                }}
                                              >
                                                <div
                                                  className="nameContainer"
                                                  style={{ width: "100%" }}
                                                >
                                                  <div className="paymakeFlexNew">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <h3
                                                        className="latoBlack font22 blackText"
                                                        style={{ fontSize: 25 }}
                                                      >
                                                        {
                                                          item.property
                                                            .property_name
                                                        }
                                                      </h3>
                                                      {/* <span
                                                        className="sRating"
                                                        style={{
                                                          display:
                                                            "inline-flex",
                                                          marginTop: "5px",
                                                          marginLeft: "10px",
                                                          marginRight: 10,
                                                        }}
                                                      >
                                                        {this.starsCount(
                                                          item.property
                                                            .star_category_id
                                                        )}
                                                      </span> */}
                                                    </div>
                                                    
                                                  </div>
                                                 
                                                  <p>
                                                    {
                                                      item.property
                                                        .address_line_1
                                                    }
                                                  </p>

                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      marginTop: 5,
                                                      fontSize: 18,
                                                      marginBottom: 2,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    {item.property_rooms.map(
                                                      (i) =>
                                                        ReactHtmlParser(
                                                          i.property_rooms &&
                                                            i.property_rooms.replace(
                                                              "</br>",
                                                              ", "
                                                            )
                                                        ).join(",")
                                                    )}
                                                  </h3>

                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      fontSize: 18,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Amount :{" "}
                                                    <FontAwesomeIcon
                                                      icon={faEuroSign}
                                                      style={{ fontSize: 16 }}
                                                      color="#000"
                                                    ></FontAwesomeIcon>{" "}
                                                    {upcomingData.hotel_link.bookingArr[
                                                      index
                                                    ].room_charges.slice(5, 13)}
                                                  </h3>
                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      fontSize: 18,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Status: {StatusMsg}
                                                  </h3>
                                                  {/* <p>Message: {Message}</p>
                                                    <p>Transaction Id: {TransactionID}</p> */}

                                                  <div
                                                    class="chkContBooking"
                                                    style={{ marginTop: 12 }}
                                                  >
                                                    <div class="chkCont__col">
                                                      <div class="paymakeFlex column">
                                                        <span class="font10 grayText appendBottom3">
                                                          CHECK IN
                                                        </span>
                                                        <span class="latoBlack font24 blackText appendBottom3">
                                                          {moment(
                                                            upcomingData
                                                              .hotel_link
                                                              .bookingArr[index]
                                                              .booking_checked_in
                                                          ).format("D MMM Y")}
                                                        </span>
                                                        <span class="font10 grayText 444">
                                                          {moment(
                                                            upcomingData
                                                              .hotel_link
                                                              .bookingArr[index]
                                                              .booking_checked_in
                                                          ).format("dddd")}
                                                        </span>
                                                      </div>
                                                      <div class="chkCont__night">
                                                        <span>
                                                          {numberOfNights}{" "}
                                                          Nights
                                                        </span>
                                                      </div>
                                                      <div class="paymakeFlex column">
                                                        <span class="font10 grayText appendBottom3">
                                                          CHECK OUT
                                                        </span>
                                                        <span class="latoBlack font24 blackText appendBottom3">
                                                          {moment(
                                                            upcomingData
                                                              .hotel_link
                                                              .bookingArr[index]
                                                              .booking_checked_out
                                                          ).format("D MMM Y")}
                                                        </span>
                                                        <span class="font10 grayText">
                                                          {moment(
                                                            upcomingData
                                                              .hotel_link
                                                              .bookingArr[index]
                                                              .booking_checked_out
                                                          ).format("dddd")}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </>
                              )}

                              {upcomingData.hs_portal && (
                                <>
                                  {" "}
                                  {upcomingData.hs_portal.propertyData.map(
                                    (item, index) => {
                                      //   console.log('HS');
                                      let date1 = new Date(
                                        upcomingData.hs_portal.bookingArr[
                                          index
                                        ].booking_checked_in
                                      );
                                      let date2 = new Date(
                                        upcomingData.hs_portal.bookingArr[
                                          index
                                        ].booking_checked_out
                                      );

                                      let timeDiff = Math.abs(
                                        date1.getTime() - date2.getTime()
                                      );
                                      let numberOfNights = Math.ceil(
                                        timeDiff / (1000 * 3600 * 24)
                                      );
                                      const Status = upcomingData
                                        .hs_portal.bookingArr[index]
                                        .booking_status;
                                      let hsbooking_id = upcomingData
                                        .hs_portal.bookingArr[index].id;
                             

                                      let StatusMsg = "";
                                      if (Status == 1) {
                                        StatusMsg = "Booking confirmed";
                                      }else{
                                        StatusMsg = "We will try to rebook the same. In case if you don’t hear from us in next 24 Hours, you can mail  us at info@holidays-seychelles.com or contact us at +248 437 6666";
                                      }
                                      return (
                                        <>
                                          <div className="Container-Tile">
                                            <div className="ContainerFlex">
                                              <div
                                                className="ContainerImage"
                                                style={{
                                                  padding: "15px 1px 10px 1px",
                                                }}
                                              >
                                                <img
                                                  src={
                                                    upcomingData
                                                      .hs_portal.property_image[
                                                    index
                                                    ][0]
                                                  }
                                                />
                                              </div>
                                              <div
                                                className="ContainerContent"
                                                style={{
                                                  padding:
                                                    "10px 10px 10px 10px",
                                                }}
                                              >
                                                <div
                                                  className="nameContainer"
                                                  style={{ width: "100%" }}
                                                >
                                                  <div className="paymakeFlexNew">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <h3
                                                        className="latoBlack font22 blackText"
                                                        style={{ fontSize: 25 }}
                                                      >
                                                        {
                                                          item.property
                                                            .property_name
                                                        }
                                                      </h3>
                                                      {/* <span
                                                        className="sRating"
                                                        style={{
                                                          display:
                                                            "inline-flex",
                                                          marginTop: "5px",
                                                          marginLeft: "10px",
                                                          marginRight: 10,
                                                        }}
                                                      >
                                                        {this.starsCount(
                                                          item.property
                                                            .star_category_id
                                                        )}
                                                      </span> */}
                                                    </div>
                                                   
                                                  </div>
                                                
                                                  <p>
                                                    {
                                                      item.property
                                                        .address_line_1
                                                    }
                                                  </p>

                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      marginTop: 5,
                                                      fontSize: 18,
                                                      marginBottom: 2,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                     {item.property_rooms
                                                      .map(
                                                        (i) =>
                                                        i.property_rooms &&
                                                        i.property_rooms.replace(
                                                            "</br>",
                                                            ", "
                                                          )
                                                      )
                                                      .join(",")}
                                                  </h3>

                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      fontSize: 18,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Amount :{" "}
                                                    <FontAwesomeIcon
                                                      icon={faEuroSign}
                                                      style={{ fontSize: 16 }}
                                                      color="#000"
                                                    ></FontAwesomeIcon>{" "}
                                                    {upcomingData.hs_portal.bookingArr[
                                                      index
                                                    ].room_charges.slice(5, 13)}
                                                  </h3>
                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      fontSize: 18,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Status: {StatusMsg}
                                                  </h3>
                                                  {/* <p>Message: {Message}</p>
                                                    <p>Transaction Id: {TransactionID}</p> */}

                                                  <div
                                                    class="chkContBooking"
                                                    style={{ marginTop: 12 }}
                                                  >
                                                    <div class="chkCont__col">
                                                      <div class="paymakeFlex column">
                                                        <span class="font10 grayText appendBottom3">
                                                          CHECK IN
                                                        </span>
                                                        <span class="latoBlack font24 blackText appendBottom3">
                                                          {moment(
                                                            upcomingData
                                                              .hs_portal
                                                              .bookingArr[index]
                                                              .booking_checked_in
                                                          ).format("D MMM Y")}
                                                        </span>
                                                        <span class="font10 grayText 444">
                                                          {moment(
                                                            upcomingData
                                                              .hs_portal
                                                              .bookingArr[index]
                                                              .booking_checked_in
                                                          ).format("dddd")}
                                                        </span>
                                                      </div>
                                                      <div class="chkCont__night">
                                                        <span>
                                                          {numberOfNights}{" "}
                                                          Nights
                                                        </span>
                                                      </div>
                                                      <div class="paymakeFlex column">
                                                        <span class="font10 grayText appendBottom3">
                                                          CHECK OUT
                                                        </span>
                                                        <span class="latoBlack font24 blackText appendBottom3">
                                                          {moment(
                                                            upcomingData
                                                              .hs_portal
                                                              .bookingArr[index]
                                                              .booking_checked_out
                                                          ).format("D MMM Y")}
                                                        </span>
                                                        <span class="font10 grayText">
                                                          {moment(
                                                            upcomingData
                                                              .hs_portal
                                                              .bookingArr[index]
                                                              .booking_checked_out
                                                          ).format("dddd")}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </>
                              )}

                              {upcomingTourData.expreriance && (
                                <>
                                  {" "}
                                  {upcomingTourData.expreriance.tourData.map(
                                    (item, index) => {
                                      //   console.log('HS');
                                      let date1 = new Date(
                                        upcomingTourData.expreriance.tourbookingArr[
                                          index
                                        ].tour_booking_date
                                      );
                                      let date2 = new Date(
                                        upcomingTourData.expreriance.tourbookingArr[
                                          index
                                        ].tour_booking_date
                                      );

                                      let timeDiff = Math.abs(
                                        date1.getTime() - date2.getTime()
                                      );
                                      let numberOfNights = Math.ceil(
                                        timeDiff / (1000 * 3600 * 24)
                                      );
                                      const Status = upcomingTourData
                                        .expreriance.tourbookingArr[index]
                                        .booking_status;
                                      let hstourbooking_id = upcomingTourData
                                        .expreriance.tourbookingArr[index].id;

                                        //Start PDF Data For Experice Listing
                                       let totalNumber = 0;
                                        if(upcomingTourData.expreriance.tourData[index].tour_guest_detail[0].price_type == 1 ){ 
                                       let number_adult =  upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_adult * 1), 0) > 0 && upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_adult * 1), 0);

                                       let number_child =  upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_child * 1), 0) > 0 && upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + v.number_child * 1, 0);

                                       let number_infant =  upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_infant * 1), 0) > 0 && upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_infant * 1), 0);

                                       let number_youth =  upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_youth * 1), 0) > 0 && upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_youth * 1), 0);

                                       let number_senior =  upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_senior * 1), 0) > 0 && upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_senior * 1), 0);
                                       totalNumber = number_adult+ number_child+number_infant+number_youth+number_senior;
                                        }else{
                                          totalNumber = upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_traveler * 1), 0) > 0 && upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_traveler * 1), 0);
                                        }
                                    
                                      let StatusMsg = "";
                                      if (Status == 1) {
                                        StatusMsg = "Booking confirmed";
                                      }else{
                                        StatusMsg = "We will try to rebook the same. In case if you don’t hear from us in next 24 Hours, you can mail  us at info@holidays-seychelles.com or contact us at +248 437 6666";
                                      }
                                      return (
                                        <>
                                          <div className="Container-Tile">
                                            <div className="ContainerFlex">
                                              <div
                                                className="ContainerImage"
                                                style={{
                                                  padding: "15px 1px 10px 1px",
                                                }}
                                              >
                                                <img
                                                  src={
                                                    upcomingTourData
                                                      .expreriance.tour_image[
                                                    index
                                                    ][0]
                                                  }
                                                />
                                              </div>
                                              <div
                                                className="ContainerContent"
                                                style={{
                                                  padding:
                                                    "10px 10px 10px 10px",
                                                }}
                                              >
                                                <div
                                                  className="nameContainer"
                                                  style={{ width: "100%" }}
                                                >
                                                  <div className="paymakeFlexNew">
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                      }}
                                                    >
                                                      <h3
                                                        className="latoBlack font22 blackText"
                                                        style={{ fontSize: 25 }}
                                                      >
                                                        {
                                                          item.tour
                                                            .tour_name
                                                        }
                                                      </h3>
                                                   
                                                    </div>
                                                  
                                                    
                                                    
                                                  </div>
                                                 
                                                  <p>
                                                    {
                                                      item.tour
                                                        .tour_location
                                                    }
                                                  </p>

                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      marginTop: 5,
                                                      fontSize: 18,
                                                      marginBottom: 2,
                                                      fontWeight: "bold",
                                                    }}
                                                  >

                                                   
                                                  </h3>

                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      fontSize: 18,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Amount :{" "}
                                                    <FontAwesomeIcon
                                                      icon={faEuroSign}
                                                      style={{ fontSize: 16 }}
                                                      color="#000"
                                                    ></FontAwesomeIcon>{" "}
                                                    {upcomingTourData.expreriance.tourbookingArr[
                                                      index
                                                    ].tour_charges.slice(5, 13)}
                                                  </h3>
                                                  <h3
                                                    className="latoBlack font22 blackText"
                                                    style={{
                                                      fontSize: 18,
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    Status: {StatusMsg}
                                                  </h3>
                                                  {/* <p>Message: {Message}</p>
                                                    <p>Transaction Id: {TransactionID}</p> */}

                                                  <div class="chkContBooking">
                                                    <div class="chkCont__col">
                                                      <div class="paymakeFlex column">
                                                        <span class="font10 grayText appendBottom3">Date</span><span class="latoBlack font24 blackText appendBottom3"> <span class="latoBlack font24 blackText appendBottom3">
                                                          {moment(
                                                            upcomingTourData
                                                              .expreriance
                                                              .tourbookingArr[index]
                                                              .tour_booking_date
                                                          ).format("D MMM Y")}
                                                        </span>
                                                          <span class="font10 grayText 444">
                                                            {moment(
                                                              upcomingTourData
                                                                .expreriance
                                                                .tourbookingArr[index]
                                                                .tour_booking_date
                                                            ).format("dddd")}
                                                          </span></span>
                                                      </div>
                                                      <div class="chkCont__night"><span></span></div>
                                                      <div class="paymakeFlex column">
                                                        <span class="font10 grayText appendBottom3">Time</span><span class="latoBlack font24 blackText appendBottom3">{upcomingTourData.expreriance.tourData[index].tour_guest_detail[0].departure_time == null ? (<>Coordinated Times</>) : (<>{upcomingTourData.expreriance.tourData[index].tour_guest_detail[0].departure_time}</>)}

                                                        </span>
                                                      </div>
                                                    </div>
                                                    <div class="chkCont__col"><p class="font16 blackText">

                                                      {upcomingTourData.expreriance.tourData[index].tour_guest_detail[0].price_type == 1 ? (<>
                                                        {upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_adult * 1), 0) > 0 && <><span class="latoBlack">{upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_adult * 1), 0)}</span>&nbsp;Adults,&nbsp;</>}

                                                        {upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_child * 1), 0) > 0 && <><span class="latoBlack">{upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + v.number_child * 1, 0)}</span>&nbsp;Children&nbsp;</>}

                                                        {upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_infant * 1), 0) > 0 && <><span class="latoBlack">{upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_infant * 1), 0)}</span>&nbsp;Infant,&nbsp;</>}

                                                        {upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_youth * 1), 0) > 0 && <><span class="latoBlack">{upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_youth * 1), 0)}</span>&nbsp;Youth,&nbsp;</>}

                                                        {upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_senior * 1), 0) > 0 && <><span class="latoBlack">{upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_senior * 1), 0)}</span>&nbsp;Senior,&nbsp;</>}
                                                      </>) : (<>
                                                        {upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_traveler * 1), 0) > 0 && <><span class="latoBlack">{upcomingTourData.expreriance.tourData[index].tour_guest_detail.reduce((a, v) => a + (v.number_traveler * 1), 0)}</span>&nbsp;Travelers,&nbsp;</>}
                                                      </>)}
                                                    </p></div>

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                </>
                              )}




                            </>
                          )}
                           <p class="errorLinkText latoBold font16 blueText"><Link to="/PlanTrips">Back To My Booking</Link></p>
                    </div>
                   
                </div>
            </div>
           



        </>
    )
}

export default BookingPage;
